import { capitaliseWords } from 'utils';

export const formatReason = (reason = ''): string =>
  capitaliseWords(reason.split('_').join(' '));
